import * as React from 'react';
import {Provider} from 'react-redux';
import * as ReactDOM from 'react-dom';
import {I18nextProvider} from 'react-i18next';
import i18n from './../i18n/client-i18n';
import App from './containers/App';
import configureStore from './store/configureStore';
import {updateSubscriptionStatus} from './store/subscriptionMiddleware';
import {BrowserRouter} from 'react-router-dom';
import fedopsLogger from './utils/fedopsLogger';
import {setAccountMannagerMode, ACCOUNT_MANAGER_PARAM} from './actions';
import {getURLParameterByName} from './utils/url';
import {initConsentPolicyAndTagManagers} from './utils/initConsentPolicyAndTagManagerClients';

fedopsLogger.init();

const initialI18n = window.__INITIAL_I18N__;
const baseUrl = window.__BASEURL__;
const initialState = window.__INITIAL_STATE__;
const consentPolicy = window.__CONSENT_POLICY__;

initConsentPolicyAndTagManagers({
  baseUrl,
  consentPolicy,
  language: initialI18n.locale,
});

const store = configureStore(initialState);
setTimeout(() => updateSubscriptionStatus(store), 0);

const isAccountManagerMode: boolean = Boolean(getURLParameterByName(ACCOUNT_MANAGER_PARAM, window.location.search));
setAccountMannagerMode(isAccountManagerMode);

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n(initialI18n)}>
      <BrowserRouter basename={baseUrl}>
        <App/>
      </BrowserRouter>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);
